import * as React from 'react'
import { ISystemBase } from '../types/ISystemBase';
import { SystemBase } from '../common/SystemBase';

interface ISystemLabel  {
}

/**
 * Creates a Label 
 * */
export default class SystemLabel extends SystemBase<ISystemLabel>
{
    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <this.WrapperDiv>
                <span className="font-weight-bolder">{this.state.value}</span>
            </this.WrapperDiv>
        );
    }
}
